import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function MiddleEastern() {
  return (
    <ApiCommunityDirectoryPage
      community="Middle Eastern"
      eyebrow="Middle Eastern community guide"
      title="Middle Eastern favorites, businesses, and local essentials in San Antonio."
      
      tags={["Middle Eastern community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Middle Eastern community guide?"
      modalIdPrefix="middle-eastern-directory"
    />
  );
}
